import { updateData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN, CAMPAIGNv3 } from './mediaPlanning';
import { CountryFormState } from '../../../store/planStore';

export interface UpdatePlanResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  planName: string;
}

export interface UpdatePlanBody {
  campaignName: string;
  division: string;
  brand: string;
  category: string;
  countrySetup: Record<string, Partial<CountryFormState>>;
}
export const updatePlan = async ({
  body,
  id,
}: {
  body: UpdatePlanBody;
  id: string;
}) => {
  return updateData<ApiResponse<UpdatePlanResponse>>(
    `/${CAMPAIGN}/media-plans/${id}`,
    body
  );
};
